import { render, staticRenderFns } from "./TrackAudioAnalysis.vue?vue&type=template&id=0c3f0051&scoped=true&"
import script from "./TrackAudioAnalysis.vue?vue&type=script&lang=js&"
export * from "./TrackAudioAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TrackAudioAnalysis.vue?vue&type=style&index=0&id=0c3f0051&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f0051",
  null
  
)

export default component.exports